module.exports = __webpack_public_path__ + "static/media/g3.73ed72ba.png";